// extracted by mini-css-extract-plugin
export default {"button":"mimic___styles_button__7OLl4","processing":"mimic___styles_processing__r2Xaq","loader":"mimic___styles_loader__g6eIx"};